"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowSize = void 0;
var react_1 = require("react");
function getSize() {
    if (typeof window !== 'undefined') {
        return {
            innerHeight: window.innerHeight,
            innerWidth: window.innerWidth,
            outerHeight: window.outerHeight,
            outerWidth: window.outerWidth,
        };
    }
    return undefined;
}
function useWindowSize() {
    var _a = (0, react_1.useState)(getSize()), windowSize = _a[0], setWindowSize = _a[1];
    function handleResize() {
        setWindowSize(getSize());
    }
    (0, react_1.useEffect)(function () {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', handleResize);
        }
        return function () {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, []);
    return windowSize;
}
exports.useWindowSize = useWindowSize;
//# sourceMappingURL=window-size.js.map